import { Skeleton } from '@mui/material'

import { Organism } from '@/core/architecture'

export const RankingUserDataListItemSkeleton: Organism = () => (
  <Skeleton height={60} variant="rectangular" sx={{ borderRadius: 1 }} />
)
